module.exports = __webpack_public_path__ + "static/media/ford-start-sync.82e24357.png";